import { render } from "./TagMatrixDataOption.vue?vue&type=template&id=ecbb0b1a&scoped=true"
import script from "./TagMatrixDataOption.vue?vue&type=script&lang=js"
export * from "./TagMatrixDataOption.vue?vue&type=script&lang=js"

import "./TagMatrixDataOption.vue?vue&type=style&index=0&id=ecbb0b1a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecbb0b1a"]])

export default __exports__